import { IntegrationsRoute } from 'routes';

export const RosaRoute = `${IntegrationsRoute}/rosa`;
export const ExactOnlineRoute = `${IntegrationsRoute}/exact-online`;
export const InvoiceForwardingRoute = `${IntegrationsRoute}/invoice-forwarding`;
export const ExactGlobeRoute = `${IntegrationsRoute}/exact-globe`;
export const PeppolRoute = `${IntegrationsRoute}/peppol`;
export const CochlearRoute = `${IntegrationsRoute}/cochlear`;
